interface ArrowDownIconProps {
  size?: number;
  fill?: string;
  className?: string;
}

/**
 * Arrow down icon
 * Source: frontend/assets/icons/arrow-down-grey.svg
 */
export default function ArrowDownIcon({
  size = 24,
  fill = '#4D5762',
  className,
}: ArrowDownIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.7096 14.8238L16.9496 10.5838C17.0433 10.4909 17.1177 10.3803 17.1685 10.2584C17.2192 10.1366 17.2454 10.0059 17.2454 9.87384C17.2454 9.74183 17.2192 9.61112 17.1685 9.48926C17.1177 9.3674 17.0433 9.2568 16.9496 9.16384C16.7622 8.97759 16.5087 8.87305 16.2446 8.87305C15.9804 8.87305 15.7269 8.97759 15.5396 9.16384L11.9996 12.7038L8.45956 9.16384C8.2722 8.97759 8.01875 8.87305 7.75456 8.87305C7.49038 8.87305 7.23693 8.97759 7.04956 9.16384C6.95688 9.25728 6.88356 9.3681 6.83379 9.48993C6.78403 9.61177 6.7588 9.74223 6.75956 9.87384C6.7588 10.0054 6.78403 10.1359 6.83379 10.2577C6.88356 10.3796 6.95688 10.4904 7.04956 10.5838L11.2896 14.8238C11.3825 14.9176 11.4931 14.992 11.615 15.0427C11.7368 15.0935 11.8676 15.1196 11.9996 15.1196C12.1316 15.1196 12.2623 15.0935 12.3841 15.0427C12.506 14.992 12.6166 14.9176 12.7096 14.8238Z"
        fill={fill}
      />
    </svg>
  );
}
